// extracted by mini-css-extract-plugin
export default {"image_section":"donationSelection_image_section__bg0cO","main":"donationSelection_main__QOEoZ","App":"donationSelection_App__jtBYB","image":"donationSelection_image__0NR6c"};